import PropTypes from 'prop-types';
import { Image } from '../shared';

const DifferenceSection = (props) => {
    return (
        <div className='difference-section-container'>
            <div className='difference-section'>
                <div className='difference-container container-root container-root-maxWidthLg'>
                    <div className='difference-text-container'>
                        <p className='dummy-header-one difference-dummy-header-one'>
                            {props.title}
                        </p>
                        <p className='difference-paragraph'>{props.paragraph}</p>
                    </div>
                </div>
            </div>
            <div className='difference-image-container'>
                <Image src={props.imgSrc} alt={props.imgAlt} className='difference-image' isOldImage />
            </div>
        </div>
    );
};

export default DifferenceSection;

DifferenceSection.propTypes = {
    title: PropTypes.string,
    paragraph: PropTypes.string,
    imgSrc: PropTypes.string,
    imgAlt: PropTypes.string,
};

